import axios from 'axios';
import type { User, BriefingItem, ProactiveItem, QuickMenuItem, RecentWorkingItem, NoticeItem, DetectedSuggestion } from '../types';

const api = axios.create({ baseURL: '/api' });

export const fetchUser = (): Promise<User> =>
  api.get<User>('/user').then(r => r.data);

export const fetchBriefing = (): Promise<BriefingItem[]> =>
  api.get<BriefingItem[]>('/briefing').then(r => r.data);

// 배포본에서는 /api/proactive를 서빙하는 주체가 없어 SPA fallback(index.html 문자열)이
// 200으로 돌아올 수 있다 — 배열이 아니면 빈 배열로 떨어뜨려 mapProactiveItems가 터지지 않게 한다
export const fetchProactive = (): Promise<ProactiveItem[]> =>
  api.get<ProactiveItem[]>('/proactive').then(r => (Array.isArray(r.data) ? r.data : []));

export const fetchQuickMenu = (): Promise<QuickMenuItem[]> =>
  api.get<QuickMenuItem[]>('/quick-menu').then(r => r.data);

export const fetchRecentWorking = (): Promise<RecentWorkingItem[]> =>
  api.get<RecentWorkingItem[]>('/recent-working').then(r => r.data);

export const fetchNotices = (): Promise<NoticeItem[]> =>
  api.get<NoticeItem[]>('/notices').then(r => r.data);

// sourceCardId 있으면 해당 카드 후속 제안, 없으면 default 반환
export const fetchDetectedSuggestions = (sourceCardId?: string): Promise<DetectedSuggestion[]> =>
  api.get<DetectedSuggestion[]>('/detected-suggestions', {
    params: sourceCardId ? { sourceCardId } : {},
  }).then(r => r.data);
